import { Card, Typography } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import NoDataFound from "../../components/NoDataFound";
import LoadingGif from "../../assets/loading_anim.gif";
import dayjs from "dayjs";
import { LIST_HEAD_EMPTYING_TABLE_HEAD } from "../../variables/constants";
import toast from "react-hot-toast";
import { getServices } from "../../apiServices/apiServices";
import moment from "moment";

//const getTodayDate = () => dayjs().subtract(1, "day").format("YYYY-MM-DD");
const getTodayDate = () => dayjs().format("YYYY-MM-DD");
function HeadEmptyingReport() {
  const [emptyingList, setEmptyingList] = useState([]);
  const [loading, setLoading] = useState({
    screen: false,
  });
  const [filterData, setFilterData] = useState({
    date: getTodayDate(),
  });
  const access_token = localStorage.getItem("gassol-head-branch-token");

  useEffect(() => {
    fetchEmptyingList();
  }, [filterData]);

  const fetchEmptyingList = async () => {
    setLoading({ ...loading, screen: true });
    try {
      const res = await getServices(
        `/api/emptying/report?date=${filterData.date}`,
        access_token
      );
      setLoading({ ...loading, screen: false });

      if (res.responseCode === 200) {
        setEmptyingList(res.responseData);
      } else {
        setEmptyingList([]);
      }
    } catch (error) {
      setLoading({ ...loading, screen: false });
      toast.error(error);
    }
  };
  console.log("emptyingList", emptyingList);

  return (
    <>
      <div className="px-6 pb-5 flex flex-col gap-6 pt-4 lg:pt-0">
        <div className="flex justify-between items-center gap-3">
          <p className="text-xl sm:text-2xl md:text-5xl font-bold">
            Emptying Report
          </p>

          <div className="flex flex-col w-[250px]">
            <label className="font-semibold">Date: </label>
            <input
              name="filter_date"
              type="date"
              onKeyDown={(e) => e.preventDefault()}
              value={filterData.date}
              onChange={(e) =>
                setFilterData({
                  ...filterData,
                  date: e.target.value,
                })
              }
              max={getTodayDate()}
              className="bg-gray-200 px-3 py-2 rounded-md border border-gray-600 outline-none"
            />
          </div>
        </div>

        {!loading.screen ? (
          <>
            {emptyingList.length > 0 ? (
              <Card
                className="h-full w-full rounded-none overflow-x-scroll md:overflow-x-hidden"
                style={{
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)",
                }}
              >
                <div className="overflow-x-auto">
                  <table className="w-full min-w-max table-auto text-left overflow-x-auto">
                    <thead>
                      <tr>
                        {LIST_HEAD_EMPTYING_TABLE_HEAD.map((head) => (
                          <th
                            key={head}
                            className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                          >
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins text-white font-semibold uppercase"
                            >
                              {head}
                            </Typography>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {emptyingList?.map((emptying, index) => {
                        return (
                          <tr key={index}>
                            <td className="p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-poppins font-semibold flex items-center gap-2"
                              >
                                {index + 1}.
                              </Typography>
                            </td>
                            <td className="p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-poppins font-semibold flex items-center gap-2"
                              >
                                {emptying.id ?? "-"}
                              </Typography>
                            </td>
                            <td className="p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-poppins font-semibold flex items-center gap-2"
                              >
                                {emptying.branch_name ?? "-"}
                              </Typography>
                            </td>
                            <td className="p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-poppins font-semibold flex items-center gap-2"
                              >
                                {emptying.phone ?? "-"}
                              </Typography>
                            </td>
                            <td className="p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-poppins font-semibold flex items-center gap-2"
                              >
                                Manifold {emptying.manifold ?? "-"}
                              </Typography>
                            </td>
                            <td className="p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-poppins font-semibold flex items-center gap-2"
                              >
                                {emptying.start_datetime
                                  ? moment(emptying.start_datetime).format(
                                      "DD/MM/YYYY HH:mm"
                                    )
                                  : "-"}
                              </Typography>
                            </td>
                            <td className="p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className={`font-poppins font-semibold flex items-center gap-2`}
                              >
                                {emptying.end_datetime
                                  ? moment(emptying.end_datetime).format(
                                      "DD/MM/YYYY HH:mm"
                                    )
                                  : "-"}
                              </Typography>
                            </td>
                            <td className="p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className={`font-poppins font-semibold flex items-center gap-2`}
                              >
                                {emptying.no_of_cylinder ?? "-"}
                              </Typography>
                            </td>
                            <td className="p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className={`font-poppins font-semibold flex items-center gap-2`}
                              >
                                {emptying.loaded_on ? moment(emptying.loaded_on).format(
                                      "DD/MM/YYYY HH:mm"
                                    )
                                  : "-"}
                              </Typography>
                            </td>
                            <td className="p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className={`font-poppins font-semibold text-center !block`}
                              >
                                {emptying.postrun_status
                                  ? emptying.postrun_status == 1
                                    ? "Completed"
                                    : emptying.postrun_status == 0
                                    ? "Running"
                                    : emptying.postrun_status === 2
                                    ? "Started"
                                    : emptying.postrun_status === 3
                                    ? "Loaded before empty"
                                    : emptying.postrun_status === 4
                                    ? "Emptying process successful"
                                    : emptying.postrun_status === 5
                                    ? "Detected Low Pressure at M2"
                                    : emptying.postrun_status === 6
                                    ? "Detected Low Pressure at M1"
                                    : "-"
                                  : "-"}
                              </Typography>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </Card>
            ) : (
              <NoDataFound />
            )}
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>
    </>
  );
}

export default HeadEmptyingReport;
